import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const lineup = () => {
  document.querySelectorAll(".lineup__content [data-toc]").forEach((contentEl) => {
    const tocKey = contentEl.getAttribute("data-toc");
    // 対応する目次項目（複数あっても OK）
    const tocItems = document.querySelectorAll(`.lineup__toc-item[data-toc="${tocKey}"]`);

    if (tocItems.length > 0) {
      ScrollTrigger.create({
        trigger: contentEl,
        start: "top-=1px top",
        end: "bottom top",
        onEnter: () => {
          tocItems.forEach((item) => item.classList.add("is-active"));
        },
        onEnterBack: () => {
          tocItems.forEach((item) => item.classList.add("is-active"));
        },
        onLeave: () => {
          tocItems.forEach((item) => item.classList.remove("is-active"));
        },
        onLeaveBack: () => {
          tocItems.forEach((item) => item.classList.remove("is-active"));
        },
      });
    }
  });
};
